/**
 * Chatbot conversation status constants
 * Single source of truth for all conversation states
 */
export const CHATBOT_STATUS = Object.freeze({
  IDLE: 'IDLE',
  CONNECTING: 'CONNECTING',
  STREAMING: 'STREAMING',
  COMPLETE: 'COMPLETE',
  ERROR: 'ERROR',
});

/**
 * Helper to check if status indicates streaming is in progress
 * @param {string} status - The conversation status to check
 * @returns {boolean} True if the chat is currently streaming
 */
export const isStreamingStatus = (status) => status === CHATBOT_STATUS.CONNECTING || status === CHATBOT_STATUS.STREAMING;
